import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'

// For now, inbox access is tied to recruitment module access
// This can be expanded later to include other modules
export const guardInboxAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  
  if (!user) return { name: 'Home' }
  
  // Check if user has access to recruitment module
  const hasRecruitmentAccess = isModuleActive(user.firm, 4) && user.profile?.modules?.recruitment?.isAccess
  
  // Later, add more module checks here:
  // const hasOtherModuleAccess = ...
  
  const canAccess = hasRecruitmentAccess
  
  return canAccess || { name: 'Home' }
}
